import { useMemo } from 'react';
import { InfoBanner, LinkToCase } from '@ui';
import { useRouteResources } from '@lp/features/RoutePlanner/hooks/useRouteResources';
import { useAircraftUtilizationContext } from '@lp/features/RoutePlanner/contexts/AircraftUtilizationContext';
import { getAircraftUtilizationWarningPrefix } from '@lp/features/RoutePlanner/utils';

export const AircraftUtilizationBanners = () => {
  const { Aircraft: aircrafts } = useRouteResources();
  const { utilizationsByAircraftId } = useAircraftUtilizationContext();

  const items = useMemo(() => {
    return aircrafts.flatMap((a) =>
      (utilizationsByAircraftId.get(a.resourceId) || []).map((utilization) => ({
        key: `${a.resourceId}-${utilization.id}`,
        tailNumber: a.tailNumber || utilization.aircraftResource.registration,
        utilization,
      })),
    );
  }, [aircrafts, utilizationsByAircraftId]);

  if (!items.length) return null;

  return (
    <>
      {items.map(({ key, tailNumber, utilization }) => (
        <InfoBanner key={key} iconType="warning">
          {getAircraftUtilizationWarningPrefix(tailNumber)} <LinkToCase id={utilization.caseId} />
        </InfoBanner>
      ))}
    </>
  );
};
